import { type ComponentType, type FC, type ReactNode } from "react";

import { css, cx } from "@emotion/css";
import { Colors, Spinner } from "@snapchat/snap-design-system";
import { CheckCircleIcon, type IconProps } from "@snapchat/snap-design-system-icons";

import { Flexbox } from "../../shared/components";
import { type DisabledVisibilityOptionConfig } from "../hooks/visibilityConfigs";

import {
    SpinnerContainer,
    VisibilityLabel,
    VisibilityOptionContent,
    visibilityOptionStyle,
    visibilityOptionStyleDisabled,
} from "./VisibilityOption.styles";

const icon = css`
    margin-top: 3px;
`;

interface VisibilityOptionProps {
    Icon: ComponentType<IconProps>;
    label: ReactNode;
    description: ReactNode;
    setVisibility?: () => void;
    loading?: boolean;
    selected?: boolean;
    disabledVisibilityOptionConfig?: DisabledVisibilityOptionConfig;
    className?: string;
}

export const VisibilityOption: FC<VisibilityOptionProps> = ({
    Icon,
    label,
    description,
    setVisibility,
    loading,
    selected,
    disabledVisibilityOptionConfig,
    className,
}) => {
    if (disabledVisibilityOptionConfig?.option) {
        return (
            <>
                <Flexbox
                    className={cx(visibilityOptionStyle, visibilityOptionStyleDisabled, className)}
                    justifyContent="space-between"
                >
                    <Flexbox>
                        <Icon className={icon} />
                        <VisibilityOptionContent>
                            <VisibilityLabel>{label}</VisibilityLabel>
                            <span>{disabledVisibilityOptionConfig.message}</span>
                        </VisibilityOptionContent>
                    </Flexbox>
                </Flexbox>
            </>
        );
    }

    return (
        <>
            <Flexbox
                className={cx(visibilityOptionStyle, className)}
                onClick={setVisibility}
                alignItems={"center"}
                justifyContent="space-between"
            >
                <Flexbox>
                    <Icon className={icon} />
                    <VisibilityOptionContent>
                        <VisibilityLabel>{label}</VisibilityLabel>
                        <span>{description}</span>
                    </VisibilityOptionContent>
                </Flexbox>
                {selected && <CheckCircleIcon fill={Colors.Green.V100} size={16} />}
            </Flexbox>
            {loading && (
                <SpinnerContainer>
                    <Spinner />
                </SpinnerContainer>
            )}
        </>
    );
};
